module.exports = __webpack_public_path__ + "img/paperclip_round.77f109c6.svg";